import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77626af1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-body" }
const _hoisted_2 = { class: "item-title" }
const _hoisted_3 = { class: "item-title-inner" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_5 = { class: "text-grey" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = { class: "status-info" }
const _hoisted_9 = { class: "item-title-delivery-date" }

import Order from '@/model/Order';
import {useRouter} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderListItem',
  props: {
  order: {
    type: Order,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {


const router = useRouter();
function detail(order: Order) {
  router.push({name: 'order_delivery', params: {id: `${order.Nummer}`}}).catch(console.error);
};
__expose({detail});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_component_v_list_item, {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (detail(__props.order))),
    class: "order-item py-5"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_list_item_title, null, {
              default: _withCtx(() => [
                _createElementVNode("span", null, " Bestellung " + _toDisplayString(__props.order.Nummer), 1),
                ((__props.order.AnzahlLieferungen ?? 0) > 0)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 0,
                      size: "x-small",
                      class: "px-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "mr-1" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-truck-delivery")
                          ], undefined, true),
                          _: 1
                        }),
                        _createTextVNode(_toDisplayString(__props.order.AnzahlLieferungen), 1)
                      ], undefined, true),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], undefined, true),
              _: 1
            }),
            _createVNode(_component_v_list_item_subtitle, null, {
              default: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, [
                  _createTextVNode(_toDisplayString(__props.order.Lieferant.LieferantName) + " ", 1),
                  (__props.order.Lieferant.LieferantNr)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(__props.order.Lieferant.LieferantNr), 1))
                    : _createCommentVNode("", true)
                ])
              ], undefined, true),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              (__props.order.Termine.GeplantLieferDatumDate)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    class: "px-1",
                    color: __props.order.color,
                    variant: "outlined"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_avatar, {
                        class: "mr-2",
                        color: __props.order.color,
                        size: "small"
                      }, null, 8, ["color"]),
                      _createElementVNode("small", _hoisted_8, [
                        _createElementVNode("div", null, [
                          _createElementVNode("strong", null, _toDisplayString(__props.order.statusText), 1)
                        ]),
                        _createElementVNode("div", null, _toDisplayString(__props.order.Termine.GeplantLieferDatumDate), 1)
                      ]),
                      _createVNode(_component_v_icon, {
                        class: "mx-1",
                        size: "16"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.order.icon), 1)
                        ], undefined, true),
                        _: 1
                      })
                    ], undefined, true),
                    _: 1
                  }, 8, ["color"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_list_item_subtitle, null, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(__props.order.date) + " " + _toDisplayString(__props.order.time), 1)
              ], undefined, true),
              _: 1
            })
          ])
        ])
      ])
    ], undefined, true),
    _: 1
  }))
}
}

})